const getObjectForCard = ({ cardId = undefined , titleText = undefined}) => ({
  cardDataAid: cardId,
  title: {
    text: titleText,
    dataAid: "title",
  },
  titleBarDataAid: "bar",
});

const getObjectForRow = ({
  rowId = "",
  titleText = undefined,
  hasSubtitle = false,
  subtitleText = undefined,
}) => ({
  rowDataAid: rowId,
  leftIconDataAid: "left",
  title: {
    text: titleText,
    dataAid: "title"
  },
  subtitle: hasSubtitle
    ? {
      text: subtitleText,
      dataAid: "subtitle"
    }
    : undefined
})

const PROFILE_SECTION = {
  avatarDataAid: "profile",
  userDetailTitle: {
    dataAid: "title",
    // text comes from API
  },
  userDetailSubtitle: {
    completeKyc: {
      text: "Complete KYC",
      dataAid: "subtitle",
    },
    showDetails: {
      text: "Show details",
      dataAid: "subtitle",
    }
    // stored in constants
  },
  statusIconDataAid: "alert",
  arrowIconDataAid: "arrow",
};

const TRADING_BALANCE_CARD = {
  ...getObjectForCard({
    cardId: "tradingBalance",
    titleText: "Trading balance"
  }),
  balanceRow: {
    ...getObjectForRow({
      rowId: "funds",
      hasSubtitle: true,
      // title text comes from API,
      subtitleText: "Current balance",
    }),
    actionBtn: {
      text: "Add funds",
      dataAid: "link"
    },
    fetchErrorToast: {
      text: "Could not fetch Fund Balance. Please try again later"
    }
  },
};

const EQUITY_PLANS_CARD = {
  ...getObjectForCard({
    cardId: "tradingPlans",
    titleText: "Equity plans"
  }),
  freedomPlanRow: {
    ...getObjectForRow({
      rowId: "brokeragePlan",
      hasSubtitle: true,
      // title and subtitle text come from constants
    }),
    actionBtn: {
      // text comes from constants
      dataAid: "link"
    }
  },
};

const INVESTMENT_ESSENTIALS = {
  ...getObjectForCard({
    cardId: "investmentEssentials",
    titleText: "Investment essentials"
  }),
  investmentAccountStatus: {
    ...getObjectForRow({
      rowId: "investmentStatus",
      titleText: "Investment account status"
    }),
    statusIconDataAid: "alert",
    arrowIconDataAid: "arrow",
    stocksAndOption: {
      rowDataAid: "stocks",
      title: {
        text: "Stocks & IPOs",
        dataAid: "title",
      },
      statusIconDataAid: "verified",
      actionBtn: {
        dataAid: "link",
        // text comes from constants mapper
      }
    },
    mutualFund: {
      rowDataAid: "mutualFunds",
      title: {
        text: "Mutual funds",
        dataAid: "title",
      },
      statusIconDataAid: "verified",
      actionBtn: {
        dataAid: "link",
        // text comes from constants mapper
      }
    },
    futureAndOptions: {
      rowDataAid: "f&o",
      title: {
        text: "Futures & Options",
        dataAid: "title",
      },
      statusIconDataAid: "verified",
      actionBtn: {
        dataAid: "link",
        // text comes from constants mapper
      }
    },
    currency: {
      rowDataAid: "currency",
      title: {
        text: "Currency",
        dataAid: "title",
      },
      statusIconDataAid: "verified",
      actionBtn: {
        dataAid: "link",
      }
    },
  },
  bankAndMandates: getObjectForRow({ rowId: "bank&Mandates", titleText: "Banks & mandates" }),
  statements: getObjectForRow({ rowId: "bank&statements", titleText: "Statements" }),
  uploadNpsDetails: getObjectForRow({ rowId: "uploadNps", titleText: "Upload NPS details" }),
  riskProfile: {
    ...getObjectForRow({
      rowId: "riskProfile",
      titleText: "Risk profile"
    }),
    tagDataAid: "risk",
    alertIconDataAid: "alert"
  },
};

const MORE_OPTIONS = {
  ...getObjectForCard({
    cardId: "moreOptions",
    titleText: "More options"
  }),
  earnPerReferral: {
    ...getObjectForRow({
      rowId: "refer&Earn",
      titleText: (amount) => `Earn ${amount} per referral`
    }),
    inviteIconDataAid: "invite",
    inviteBtn: {
      text: "Invite",
      dataAid: "invite"
    }
  },
  applyReferralCode: getObjectForRow({
    rowId: "applyReferral",
    titleText: "Apply referral code"
  }),
  settings: getObjectForRow({
    rowId: "settings",
    titleText: "Settings"
  }),
  followUs: getObjectForRow({
    rowId: "followUs",
    titleText: "Follow us"
  }),
};

const MISCELLANEOUS = {
  pageDataAid: "myAccountLanding",
  pageTitle: {
    text: "Account",
    dataAid: "account",
  },
  appVersion: {
    // text comes from API
    dataAid: "appVersion",
  },
}

const SEGMENTS_BOTTOMSHEET = {
  dataAid: 'segments',
  title: {
    text: 'Please contact Fisdom Support via the Help feature of the app to activate the segment'
  },
  buttonTitle: {
    text: 'CONTACT SUPPORT'
  }
}

const ACCOUNT_LANDING = {
  ...MISCELLANEOUS,
  PROFILE_SECTION,
  TRADING_BALANCE_CARD,
  EQUITY_PLANS_CARD,
  INVESTMENT_ESSENTIALS,
  MORE_OPTIONS,
  SEGMENTS_BOTTOMSHEET,
};

export default ACCOUNT_LANDING;
